import React from 'react';
import { withStyles, IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  retryLabel: {
    fontSize: theme.textFontSize,
    color: theme.warningTextColorDispatch
  },
  retryText: {
    fontSize: theme.textFontSize,
    textDecorationLine: 'underline',
    color: theme.warningTextColorDispatch,
    fontWeight: 'bold',
    marginLeft: 4
  },
  button: {
    padding: '0 0 0 4'
  }
});

const Retry = ({ classes, onClick }) => {
  return (
    <div className={classes.container}>
      <span className={classes.retryLabel}>Request failed while fetching duplicate pickups</span>
      <IconButton onClick={onClick} className={classes.button}>
        <Refresh className={classes.refreshIcon} />
        <span className={classes.retryText}>RETRY</span>
      </IconButton>
    </div>
  );
};

export default withStyles(styles)(Retry);
